module.exports = __webpack_public_path__ + "static/media/13.3f03e65c.jpeg";